import { ConfigServiceProvider } from '../config-service/config-service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MapOfNumberTo } from '../../../ranking/interfaces/utils';
import { StorageServiceProvider } from '../storage-service/storage-service';
import { User } from './interfaces/user.interface';
import { UserDisplay } from './interfaces/user-display.interface';

@Injectable()
export class UsersServiceProvider {
  private readonly defaultPhotoPath = 'assets/images/photo_placeholder.png';
  private users: MapOfNumberTo<UserDisplay>;

  constructor(public http: HttpClient, private configService: ConfigServiceProvider, private storageService: StorageServiceProvider) {}

  public load() {
    return new Promise<void>((resolve, reject) => {
      this.http
        .get<User[]>(this.configService.getUrl('users'))
        .toPromise()
        .then(
          (response: MapOfNumberTo<UserDisplay>) => {
            this.users = this.replaceNullPhotosWithDefault(response);
            return this.storageService.setObject('users', this.users);
          },
          (err) => reject(err),
        )
        .then(
          () => resolve(),
          (err) => reject(err),
        );
    });
  }

  private replaceNullPhotosWithDefault(usersMap: MapOfNumberTo<UserDisplay>): MapOfNumberTo<UserDisplay> {
    Object.keys(usersMap).forEach((key) => (usersMap[key] = usersMap[key] === null ? this.defaultPhotoPath : usersMap[key]));
    return usersMap;
  }

  public getChildren(userId?: number): Promise<User[]> {
    let url: string;
    if (userId) url = this.configService.getUrl('userIdChildren').replace('{userId}', userId.toString());
    else url = this.configService.getUrl('userChildren');
    return this.http.get<User[]>(url).toPromise();
  }

  public getUsers(): Promise<MapOfNumberTo<UserDisplay>> {
    return this.storageService.getObject('users');
  }

  public getUsersProperty(): MapOfNumberTo<UserDisplay> {
    return this.users;
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/users-service/users-service.ts